import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Reviews.css';
import cs from '../../components/commonStyle.css';


// Component
import ResponseItem from './ResponseItem';
import Avatar from '../Avatar/Avatar';
import { getDynamicTitle } from '../../helpers/GetDynamicItemName/getDynamicName';
import { dateFormat } from '../../config';

// Locale
import messages from '../../locale/jsonMessages';
import StarRating from '../StarRating/StarRating';

const ResponseMeItem = (props) => {

    const locale = useSelector(state => state.intl.locale);
    const dynamicListTitle = useSelector(state => state?.dynamicListTitles?.data?.dynamicListTitle)

    const { firstName, lastName, profileId, picture, isAdmin, listData, reservationData } = props;
    const { reviewContent, createdAt, response, showUserName, rating, userData } = props;
    let date = moment(parseInt(createdAt)).format('L');

    let isGuestImage = response && response.authorData && response.authorData.picture || userData.picture;
    let isGuestProfileId = response && response.authorData && response.authorData.profileId || userData.profileId;
    let isGuestName = response && response.authorData && response.authorData.firstName || userData.firstName;
    let isProfileId, listTitle, dynamicTitle;
    if (!showUserName) {
        isProfileId = profileId
    } else {
        isProfileId = isGuestProfileId
    }
    listTitle = reservationData.listTitle

    dynamicTitle = getDynamicTitle({ data: dynamicListTitle, locale, id: listData?.id });

    return (
        <li className={cx(cs.paddingBottom4)}>
            <div className={cx(s.listAvatarGrid, cs.reviewsContainer)}>
                <div className={cx(cs.reviewsYourItemsOne, cs.reviewsYourLs)}>
                    {
                        !isAdmin && <div className={cx(s.textCenter, 'reviewsId')} >
                            <Avatar
                                source={isGuestImage}
                                title={isGuestName}
                                className={s.profileAvatar}
                                withLink
                                linkClassName={cx(cs.commonProfileAvatarLink, s.noBackground)}
                                profileId={isGuestProfileId}
                            />
                        </div>
                    }
                </div>
                <div className={cx(s.listDeatilsGrid, cs.reviewsYourItemsTwo, cs.rightBg, 'rightBgRTL', 'reviewDeatilsGridRTL', 'bgBlackTwo', 'dashRightBg')}>
                    <div className={cx(cs.dFlexColumn)}>
                        {
                            showUserName && <span className={cx(cs.writtenReviewTitle)}>
                                {listData &&
                                    <>
                                        <FormattedMessage {...messages.youHadReviewsFor} />{' '}
                                        <a href={"/cars/" + listData.id} target={"_blank"} className={cx(cs.reviewTitleLink, cs.commonContentText)}>{dynamicTitle ? dynamicTitle : (listTitle ? listTitle : listData.title)}</a>
                                    </>
                                }
                                {!listData &&
                                    <FormattedMessage {...messages.notAvailable} />
                                }
                            </span>
                        }


                        {
                            !isAdmin && !showUserName &&
                            <div className={cx(cs.writtenReviewTitle)}>

                                {listData &&
                                    <>
                                        {isGuestName}<span className={cx(cs.reviewHeadingColor)}>{' '}<FormattedMessage {...messages.sReview} /></span>
                                        <a href={"/cars/" + listData.id} target={"_blank"} className={cx(cs.reviewTitleLink, cs.commonContentText)}>{" "}{dynamicTitle ? dynamicTitle : (listTitle ? listTitle : listData.title)}</a>
                                    </>
                                }
                                {!listData &&
                                    <FormattedMessage {...messages.notAvailable} />
                                }
                            </div>
                        }
                        {
                            response?.reviewContent && <div className={cx(cs.reviewFlex, cs.dFlex, 'reviewStarSection')}>
                                <StarRating className='smallStarRatingAdjust' />
                                <div>{response?.rating}</div>
                                <span className={cx(cs.dotCss)}></span>
                                <div className={cx(s.dateReviewCss, 'textWhite', 'dateReviewCssRTL')}>{date}</div>
                            </div>
                        }
                        <p className={cx(cs.reviewPara, cs.commonMediumText, s.contentTop, s.noResponse)}>
                            {
                                response?.reviewContent && (response?.reviewContent.trim()).split("\n").map(function (content, index) {
                                    return (
                                        <span key={index}>
                                            {content}
                                            <br />
                                        </span>
                                    )
                                })
                            }
                        </p>
                        <ResponseItem
                            data={{ reviewContent, rating, authorData: { firstName, lastName, profileId, picture } }}
                            date={date}
                        />
                    </div>
                </div>
            </div>
        </li>
    );
}

ResponseMeItem.propTypes = {
    picture: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    profileId: PropTypes.number,
    reviewContent: PropTypes.string,
    createdAt: PropTypes.string,
    response: PropTypes.object,
    showUserName: PropTypes.bool,
    isAdmin: PropTypes.bool
};

ResponseMeItem.defaultProps = {
    response: null,
    showUserName: false
};

export default withStyles(s, cs)(ResponseMeItem);
